// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__HtXl3","footer":"styles_footer__3UHHi","passCodeTooltip":"styles_passCodeTooltip__2S8pQ"};